export type PublicTelemetryContext = 'render' | 'query' | 'mutation' | 'window';

export interface PublicErrorEvent {
  name: 'fnbcustomer_error';
  context: PublicTelemetryContext;
  code: string;
  online: boolean;
  occurredAt: string;
}

function safeCode(error: unknown): string {
  const value = error as {
    publicCode?: unknown;
    data?: { errors?: Array<{ code?: unknown }> };
    name?: unknown;
  };
  const candidate =
    typeof value.publicCode === 'string'
      ? value.publicCode
      : value.data?.errors?.find((item) => typeof item.code === 'string')?.code;
  if (typeof candidate === 'string' && /^FNB_PUBLIC_[A-Z0-9_]{1,80}$/.test(candidate))
    return candidate;
  if (value.name === 'TypeError') return 'NETWORK_ERROR';
  return 'UNEXPECTED_ERROR';
}

export function reportPublicError(error: unknown, context: PublicTelemetryContext): void {
  if (typeof window === 'undefined') return;
  const detail: PublicErrorEvent = {
    name: 'fnbcustomer_error',
    context,
    code: safeCode(error),
    online: navigator.onLine,
    occurredAt: new Date().toISOString(),
  };
  window.dispatchEvent(new CustomEvent<PublicErrorEvent>('fnbcustomer:telemetry', { detail }));
}
